'use strict';

module.exports = function () {
    $('body').on('click', '.suggestion-search-all', function () {
        $('.suggestsearchall').removeClass('d-none');
        $('.suggestion-search-all').addClass('d-none');
    });
    $('body').on('click', '.search-show-less', function () {
        $('.suggestsearchall').addClass('d-none');
        $('.suggestion-search-all').removeClass('d-none');
    });
};
